import React, { useState } from 'react';
import './App.css';

function App() {
  const [checkedItems, setCheckedItems] = useState({});
  const [showResult, setShowResult] = useState(false);

  const questions = [
    "Lançamentos atualizados do a pagar, receber e tesouraria",
    "Conciliação Bancária efetiva e regular",
    "Gerenciamento das informações via ERP",
    "Acompanhamento em tempo real do Fluxo de caixa",
    "Geração e análise mensal da DRE",
    "Acompanhamento da Margem de Contribuição",
    "Confiabilidade e acompanhamento do EBITDA",
    "Cálculo e acompanhamento do Ponto de Equilíbrio",
    "Cálculo e acompanhamento do Ciclo Econômico",
    "Análise e acompanhamento do NCG",
    "Planejamento Orçamentário com revisões trimestrais",
    "Análise da evolução patrimonial via Balanço",
    "Monitoramento do Grau de Endividamento",
    "Acompanhamento dos Índices de Liquidez",
    "Análise contínua da Estrutura de Capital",
    "Avaliação do ROE",
    "Análise da evolução do Equity ao longo do tempo"
  ];

  const handleCheckboxChange = (index) => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const getInterpretation = (score) => {
    if (score >= 0 && score <= 5) {
      return "Sua empresa está em uma situação de risco operacional. É fundamental implementar controles básicos de gestão financeira para evitar problemas maiores. Recomendamos começar com a organização dos lançamentos e conciliação bancária.";
    } else if (score >= 6 && score <= 9) {
      return "Sua empresa possui alguns controles básicos, mas ainda há muito espaço para melhorias. É importante desenvolver processos mais estruturados e implementar ferramentas de gestão para aumentar a previsibilidade dos resultados.";
    } else if (score >= 10 && score <= 13) {
      return "Parabéns! Sua empresa possui uma boa estrutura de controle financeiro. Para evoluir ainda mais, foque em análises estratégicas como ROE, estrutura de capital e planejamento orçamentário com revisões periódicas.";
    } else {
      return "Excelente! Sua empresa possui uma gestão financeira estratégica muito bem estruturada. Continue aprimorando os processos e considere implementar análises mais avançadas para manter a vantagem competitiva.";
    }
  };

  const calculateScore = () => {
    const score = Object.values(checkedItems).filter(Boolean).length;
    setShowResult(true);
    return score;
  };

  const getClassification = (score) => {
    if (score >= 0 && score <= 5) {
      return {
        range: "0 a 5",
        title: "Caos e risco operacional",
        color: "#dc2626",
        bgColor: "#fef2f2"
      };
    } else if (score >= 6 && score <= 9) {
      return {
        range: "6 a 9",
        title: "Controle básico com baixa previsibilidade",
        color: "#ea580c",
        bgColor: "#fff7ed"
      };
    } else if (score >= 10 && score <= 13) {
      return {
        range: "10 a 13",
        title: "Boa estrutura e controle confiável",
        color: "#ca8a04",
        bgColor: "#fefce8"
      };
    } else {
      return {
        range: "14+",
        title: "Gestão financeira estratégica",
        color: "#16a34a",
        bgColor: "#f0fdf4"
      };
    }
  };

  const score = Object.values(checkedItems).filter(Boolean).length;
  const classification = getClassification(score);

  return (
    <div className="App">
      <header className="app-header">
        <div className="logo">
          <img src="/oito-leme-logo.png" alt="Oito Leme" className="logo-image" />
        </div>
      </header>

      <main className="main-content">
        <div className="title-section">
          <h1 className="main-title">
            DESCUBRA O NÍVEL<br />
            DO <span className="highlight">SETOR FINANCEIRO</span><br />
            DA SUA EMPRESA
          </h1>
          <p className="subtitle">Cada item abaixo vale um (01) ponto:</p>
        </div>

        <div className="questionnaire">
          {questions.map((question, index) => (
            <label key={index} className="question-item">
              <input
                type="checkbox"
                checked={checkedItems[index] || false}
                onChange={() => handleCheckboxChange(index)}
              />
              <span className="checkmark"></span>
              <span className="question-text">{question}</span>
            </label>
          ))}
        </div>

        <button className="calculate-btn" onClick={calculateScore}>
          Calcular
        </button>

        {showResult && (
          <div className="result-section">
            <div className="classification-cards">
              <div 
                className="classification-card active"
                style={{ 
                  backgroundColor: classification.color,
                  color: 'white'
                }}
              >
                <div className="score-range">{classification.range}</div>
                <div className="classification-title">{classification.title}</div>
              </div>
            </div>
            <div className="score-display">
              Sua pontuação: <strong>{score} pontos</strong>
            </div>
            
            <div className="interpretation-box">
              <h3>Interpretação do Resultado</h3>
              <p>{getInterpretation(score)}</p>
              <p className="contact-suggestion">
                <strong>Quer melhorar ainda mais seus resultados?</strong> Entre em contato com um dos nossos especialistas para uma consultoria personalizada.
              </p>
            </div>

            <div className="action-buttons">
              <a 
                href="https://api.whatsapp.com/message/NTW4QJ2OJSX5I1?autoload=1&app_absent=0" 
                target="_blank" 
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                📱 Falar com Especialista
              </a>
              
              <a 
                href="https://www.oitoleme.com.br" 
                target="_blank" 
                rel="noopener noreferrer"
                className="learn-more-btn"
              >
                🔗 Saiba mais
              </a>
            </div>
          </div>
        )}
      </main>

      <footer className="app-footer">
        <p>Deslize para cima para ver o oitoleme.com.br</p>
      </footer>
    </div>
  );
}

export default App;
